module.exports = __webpack_public_path__ + "img/kuwait.8080bda6.svg";